/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Base from './base'
import URI from 'urijs'

// @namespace Model
class ReferralCode extends Base {
  static initClass () {
    this.prototype.idAttribute = 'code'
  }

  urlRoot () {
    return '/api/referral_codes'
  }

  reminderEmailUrl () {
    return URI(this.url()).segment('remind').toString()
  }

  sendReminder () {
    return this.save(null,
      { url: this.reminderEmailUrl() })
  }
}
ReferralCode.initClass()

export default ReferralCode
